import styled from "styled-components";

const Container = styled.div`
  h3 {
    line-height: 30px;
    background-color: #ededed;
    font-weight: bold;
  }

  label {
    margin-bottom: 5px;
    font-weight: bold;
  }

  .MuiOutlinedInput-root.filter {
    width: 100%;
    height: 90px;
  }

  .MuiOutlinedInput-root.filter .MuiOutlinedInput-input {
    position: absolute;
    top: 0;
  }

  .buttons-container {
    float: right;
  }

  .buttons-container .MuiButton-root {
    color: white;
    background-color: grey;
    width: 80px;
    margin-left: 20px;
  }
`;

const Button = styled.div`
  float: right;
  color: white;
  background-color: grey;
`;

export { Container, Button };
